/* eslint-disable */
import { Customer } from '../models/customer';
import { UpdateAcquisitionStatusRequest } from '../models/request/UpdateAcquisitionStatusRequest';
import { UpdateCustomerRequest } from '../models/request/updateCustomerRequest';
import api from '../redux/api';

const customerApiSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getCustomerDetails: build.query<Customer, void>({
      query: () => "customer/api/BaseCustomerData/customer-details",
      transformResponse: (dto: any) => new Customer(dto),
    }),
    updateCustomerInfo: build.mutation<any, UpdateCustomerRequest>({
      query: (body) => ({
        url: "customer/api/BaseCustomerData/update",
        method: "POST",
        body
      }),
    }),
    updateAcquisitionStatus: build.mutation<any, UpdateAcquisitionStatusRequest>({
      invalidatesTags: ["User"],
      query: (body) => ({
        url: "customer/api/BaseCustomerData/update/acquisition-status",
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json"
        }
      })
    }),
  }),
});

export const { useGetCustomerDetailsQuery, useUpdateCustomerInfoMutation, useUpdateAcquisitionStatusMutation } = customerApiSlice;
